export default __webpack_public_path__ + "assets/images/07970292fdf3599f3cbaab1f8b7fec87.png";